<ng-container *ngIf="items$ | async; let items">
    <div class="parent-wrapper" #parentWrapper>
        <div class="one-column-display" fxLayout="column" fxLayoutAlign="center start" *ngIf="isOneColumnDisplay">
            <ng-container *ngFor="let item of items; let last = last">
                <ng-container *ngIf="item.show">
                    <ng-container *ngTemplateOutlet="mediaView; context: { item: item.item }"></ng-container>
                    <div *ngIf="!last" class="divider"></div>
                </ng-container>
            </ng-container>
        </div>
        <div class="two-column-display" fxLayout="row" fxLayoutAlign="start start" *ngIf="!isOneColumnDisplay">
            <div class="left-column" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
                <ng-container *ngFor="let item of leftSideItemsDisplay; let last = last">
                    <ng-container *ngIf="item.show">
                        <ng-container *ngTemplateOutlet="mediaView; context: { item: item.item }"></ng-container>
                        <div *ngIf="!last" class="divider"></div>
                    </ng-container>
                </ng-container>
            </div>
            <div class="right-column" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
                <ng-container *ngFor="let item of rightSideItemsDisplay; let last = last">
                    <ng-container *ngIf="item.show">
                        <ng-container *ngTemplateOutlet="mediaView; context: { item: item.item }"></ng-container>
                        <div *ngIf="!last" class="divider"></div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="floating controls" #floatingControls>
        <button
            mat-icon-button
            [ngClass]="{ inactive: isOneColumnDisplay }"
            (click)="isOneColumnDisplay = !isOneColumnDisplay"
        >
            <mat-icon>vertical_split</mat-icon>
        </button>
        <ng-container *ngIf="!isOneColumnDisplay">
            <span *ngIf="!!leftSideItemsDisplay.length">|</span>

            <button
                *ngFor="let item of leftSideItemsDisplay"
                [ngClass]="{ inactive: !item.show }"
                mat-icon-button
                (click)="toggleItem(item.item); item.show = !item.show"
            >
                <mat-icon>{{ item.item.mediaData.icon }}</mat-icon>
            </button>

            <span *ngIf="!!rightSideItemsDisplay.length">||</span>

            <button
                *ngFor="let item of rightSideItemsDisplay"
                [ngClass]="{ inactive: !item.show }"
                mat-icon-button
                (click)="toggleItem(item.item); item.show = !item.show"
            >
                <mat-icon>{{ item.item.mediaData.icon }}</mat-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="isOneColumnDisplay">
            <button
                *ngFor="let item of items"
                [ngClass]="{ inactive: !item.show }"
                mat-icon-button
                (click)="toggleItem(item.item); item.show = !item.show"
            >
                <mat-icon>{{ item.item.mediaData.icon }}</mat-icon>
            </button>
        </ng-container>
    </div>
</ng-container>
<ng-template #mediaView let-item="item">
    <div class="media-wrapper mb-1" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
        <div
            class="media-title"
            *ngIf="!item.metadata || !item.metadata?.visibility || item.metadata?.visibility?.headline"
        >
            {{ item.title }}
        </div>
        <app-player-media-view
            class="media"
            [resourceItemTypeValue]="item.item_type_value"
            [media_id]="item.name"
            [canDownlaodMedia]="item.can_download"
            [displayName]="false"
            [ngClass]="{ 'text-material': item.item_type_value == 'text_material' }"
        >
        </app-player-media-view>
    </div>
</ng-template>
